import { fantom as viemFantom } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const fantom = {
  displayName: 'Fantom',
  runtime: 'evm',
  viemChain: viemFantom,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'fantom' },
    qnStreams: {
      networkKey: 'fantom-mainnet',
    },
  }),
} as const satisfies AllChainConfig<'evm', false>;
